import { CreateParkableTransactionMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: CreateParkableTransactionMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class CreateParkableTransactionRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PARKABLE_TRANSACTIONS,
      type: `CREATE_PARKABLE_TRANSACTION.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { CreateParkableTransactionRequest };
